module.exports = __webpack_public_path__ + "static/media/group@3x.22e49377.png";